import React, { useEffect, useState } from 'react';
import { apiFetch, formatDate } from '../../utils/api';

const Reviews = () => {
    const [reviews, setReviews] = useState([]);

    useEffect(() => {
        let cancelled = false;
        apiFetch('/reviews').then(({ ok, data }) => {
            if (!cancelled && ok && Array.isArray(data)) setReviews(data);
        });
        return () => {
            cancelled = true;
        };
    }, []);

    return (
        <>
            <h1 className="text-xl font-semibold">Reviews</h1>
            <div className="mt-5 space-y-4">
                {reviews.length === 0 && <p className="text-sm text-gray-500">You haven't reviewed any products yet.</p>}
                {reviews.map((r) => (
                    <div key={r.id} className="rounded-xl border border-gray-200 bg-white p-5 shadow-sm">
                        <div className="flex items-center justify-between">
                            <p className="text-sm font-semibold">{r.product}</p>
                            <p className="text-xs text-gray-500">{formatDate(r.createdAt)}</p>
                        </div>
                        <p className="mt-1 text-amber-500" aria-label={`${r.rating} out of 5 stars`}>
                            {'★'.repeat(r.rating)}<span className="text-gray-300">{'★'.repeat(5 - r.rating)}</span>
                        </p>
                        <p className="mt-2 text-sm text-gray-600">{r.text}</p>
                    </div>
                ))}
            </div>
        </>
    );
};

export default Reviews;
